import { createEmbedConsent } from './embedConsent';

// Vimeo's player iframes set non-essential cookies.
export const {
    consented: vimeoEmbedConsented,
    consent: consentToVimeoEmbed,
    recording: vimeoEmbedConsentRecording,
    failed: vimeoEmbedConsentFailed,
} = createEmbedConsent('vimeo');
